import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEDetentionHistoriesCardActions = {
  initPeDetentionHistoriesCard: ({ commit }, index) => {
    commit('setPeDetentionHistoriesCardLock', { index, lock: true })
  },
  peDetentionHistoriesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        detention_histories: {
          party_id: party.id,
          authority: section.authority,
          facility: section.facility,
          initiated_date: section.initiated_date,
          initiated_date_format: section.initiated_date_format,
          initiated_date_uncertain: section.initiated_date_uncertain,
          terminated_date: section.terminated_date,
          terminated_date_format: section.terminated_date_format,
          terminated_date_uncertain: section.terminated_date_uncertain,
          reason: section.reason,
          bond_amt: section.bond_amt,
          notes: section.notes,
          conditions: section.conditions,
        },
      }).
      then(({ data }) => {
        commit('setPeDetentionHistoriesCardLock', { index: 'new', lock: true })
        commit('setPeDetentionHistoriesCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'detention_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peDetentionHistoriesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/detention_histories/${section.id}`).
      then(({ data }) => {
        commit('setPeDetentionHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'detention_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peDetentionHistoriesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        detention_histories: {
          party_id: party.id,
          authority: section.authority,
          facility: section.facility,
          initiated_date: section.initiated_date,
          initiated_date_format: section.initiated_date_format,
          initiated_date_uncertain: section.initiated_date_uncertain,
          terminated_date: section.terminated_date,
          terminated_date_format: section.terminated_date_format,
          terminated_date_uncertain: section.terminated_date_uncertain,
          reason: section.reason,
          bond_amt: section.bond_amt,
          notes: section.notes,
          conditions: section.conditions,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeDetentionHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'detention_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peDetentionHistoriesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          detention_histories: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const detentionHistories = data.detention_histories

        commit('setPeDetentionHistoriesCardLock', { index, lock: true })
        commit('pePatchParty', {
          detention_histories: detentionHistories || [],
        })
      }).
      catch(handleError)
  },
  peDetentionHistoriesCardAddSection: ({ commit }) => {
    commit('setPeDetentionHistoriesCardLock', { index: 'new', lock: false })
    commit('addPeDetentionHistoriesCardSection', {
      id: null,
      authority: null,
      facility: null,
      initiated_date: null,
      initiated_date_format: null,
      initiated_date_uncertain: null,
      terminated_date: null,
      terminated_date_format: null,
      terminated_date_uncertain: null,
      reason: null,
      bond_amt: null,
      notes: null,
      conditions: null,
    })
  },
}

export const PEDetentionHistoriesCardMutations = {
  setPeDetentionHistoriesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.DetentionHistoriesCard) {
      Vue.set(state.partyEdit.partySections, 'DetentionHistoriesCard', {})
    }
    Vue.set(state.partyEdit.partySections.DetentionHistoriesCard, index, lock)
  },
  addPeDetentionHistoriesCardSection: (state, section) => {
    state.partyEdit.party.detention_histories.push(section)
  },
  peDetentionHistoriesCardCreateUndo: state => {
    state.partyEdit.party.detention_histories.pop()
    Vue.set(state.partyEdit.partySections.DetentionHistoriesCard, 'new', true)
  },
}

export const PEDetentionHistoriesCardGetters = {
  peDetentionHistoriesCardLock: state => index => state.partyEdit.partySections.DetentionHistoriesCard[index],
  peDetentionHistoriesCardHasNewSection: (_, getters) => !!getters.
    peParty.
    detention_histories?.
    find(language => language.id === null),
}
